class DragScrollHorizontal {
  constructor(root) {
    this.root = root;
    this._isDown = false;
    this._startX = 0;
    this._scrollLeft = 0;

    this.root.addEventListener("mousedown", this.dragBegin.bind(this));
    this.root.addEventListener("mouseleave", this.dragEnd.bind(this));
    this.root.addEventListener("mouseup", this.dragEnd.bind(this));
    this.root.addEventListener("mousemove", this.dragging.bind(this));
  }

  dragBegin(event) {
    this._isDown = true;
    this._startX = event.pageX - this.root.offsetLeft;
    this._scrollLeft = this.root.scrollLeft;
  }

  dragEnd() {
    this._isDown = false;
  }

  dragging(event) {
    if (!this._isDown) {
      return;
    }

    event.preventDefault();
    const x = event.pageX - this.root.offsetLeft;
    const walk = (x - this._startX);
    this.root.scrollLeft = this._scrollLeft - walk;
  }
}

window.DragScrollHorizontal = DragScrollHorizontal;

class GalleryProductCard {
  constructor(root) {
    this.root = root;
    this.image = this.root.querySelector("[data-gallery-product-card-image]");
    this.buttons = Array.from(this.root.querySelectorAll("[data-gallery-product-card-thumbnail-button]"));
    this.buttons.forEach(button => {
      button.addEventListener("click", this.setGalleryImage.bind(this, button));
    });
  }

  setGalleryImage(button) {
    this.image.src = button.dataset.galleryProductCardImageUrl;

    this.buttons.forEach(button => {
      button.removeAttribute("data-selected");
    })

    button.setAttribute("data-selected", "");
  }
}

window.GalleryProductCard = GalleryProductCard;

function main() {
  document.querySelectorAll("[data-drag-scroll-horizontal]").forEach(element => {
    element.dragScrollHorizontal = new DragScrollHorizontal(element);
  });

  document.querySelectorAll("[data-gallery-product-card]").forEach(element => {
    element.galleryProductCard = new GalleryProductCard(element);
  });
}

main();